var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "informations" },
    [
      _c(
        "v-layout",
        { attrs: { wrap: "", row: "" } },
        [
          _c(
            "v-flex",
            { attrs: { lg6: "" } },
            [
              _c(
                "v-card",
                { attrs: { flat: "" } },
                [
                  _c("v-card-title", [_vm._v("Dados do Tier")]),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { staticClass: "mb-2", attrs: { wrap: "", row: "" } },
                        [
                          _c("v-flex", { attrs: { lg6: "" } }, [
                            _c("h4", { staticClass: "secondary--text" }, [
                              _vm._v("\n                Nome\n              "),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "grey--text darken-4 mt-4" },
                              [_vm._v(_vm._s(_vm.tier.name))]
                            ),
                            _vm._v(" "),
                            _c("h4", { staticClass: "secondary--text mt-4" }, [
                              _vm._v(
                                "\n                Features\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "ul",
                              _vm._l(
                                _vm.tier.features,
                                function (feature, index) {
                                  return _c("li", { key: index }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(feature.title) +
                                        "\n                "
                                    ),
                                  ])
                                }
                              ),
                              0
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { lg6: "" } },
            [
              _c(
                "v-card",
                { attrs: { flat: "" } },
                [
                  _c("v-card-title", [_vm._v("Parceiros")]),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { staticClass: "mb-2", attrs: { wrap: "", row: "" } },
                        [
                          _c("v-flex", { attrs: { lg6: "" } }, [
                            _c("h4", { staticClass: "secondary--text mt-4" }, [
                              _vm._v(
                                "\n                Parceiros\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "ul",
                              _vm._l(
                                _vm.tier.partners,
                                function (partner, index) {
                                  return _c("li", { key: index }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(partner.name) +
                                        "\n                "
                                    ),
                                  ])
                                }
                              ),
                              0
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }